module.exports = __webpack_public_path__ + "img/Aileron_Logo_Web_wht.f0f06875.svg";